






import { Component, Mixins, Prop } from "vue-property-decorator";
import RequestedDocumentProcessor from "./helpers/RequestedDocumentProcessor.vue";
import { IBehaviorDocumentEditorValidatorsConfiguration } from "../../domain/configuration";
import { BackgroundView } from "../system";

@Component({
  components: {
    BackgroundView,
    RequestedDocumentProcessor,
  }
})
export default class NewRequestedDocumentRegisterView extends Mixins() {
  $refs!: {
    processor: RequestedDocumentProcessor,
  };

  @Prop()
  requestId: number;

  @Prop()
  completedTitle: string;

  isProcessing: boolean = true;
  message: string = "";

  mounted() {
    this.registerRequestedDocument();
  }

  get validator(): IBehaviorDocumentEditorValidatorsConfiguration {
    return this.$configuration.behavior.document.editor.validator;
  }

  get shouldApplyValueForcibly(): boolean {
    return this.$configuration.dangerZone.document.factory.shouldApplyValueForcibly;
  }

  async registerRequestedDocument(): Promise<void> {
    try {
      this.isProcessing = true;
      this.$logger.info("新規文書を記載し登録します.");
      
      // 要求内容の取得から結果の格納までを処理（エラーの場合はエラーの内容も返却してから抜ける）
      await this.$refs.processor.process(this.requestId);

      this.showMessage();
    } catch (e) {
      this.showMessage(e.message);
    } finally {
      document.title = this.completedTitle; // 完了時にブラウザのタイトルを指定された物に更新する.
      this.isProcessing = false;
      await this.$sleep(60000);  // 60秒待つ.(メッセージが読めてIE版Kickerが終了検知できる時間として.)
      this.$closeWindow(true);
    }
  }

  showMessage(message: string = "新規文書を記載し登録しました."): void {
    this.message = message;
    this.$logger.info(this.message);
  }
}
